/**
 * Created by mykurisu on 2017/9/18.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import axios from 'axios'
import LecturePage from './LecturePage'
import RecordedPage from './recordedPage/RecordedPage'
import {Preload} from '../components'
import { storage } from '../utils'


class LecturePageContainer extends React.Component {

    constructor() {
        super();
        this.state = {
            hasAudio: false,
            init: false,
            lecture: null,
            granted: false
        }
    }

    componentWillMount() {
        const {lecture_id} = this.props.routeParams;
        axios.get(`/api/lecture/${lecture_id}/info${window.location.search}`)
            .then(res => {
                if (res.data.code === 0) {
                    let data = res.data.data;
                    // 判断新版分销关系，替换直播间信息
                    if (data.src_liveroom) {
                        data.liveroom = data.src_liveroom
                        data.role.is_fans = data.src_liveroom.is_fans
                    }
                    this.props.dispatch({
                        type: 'LECTURE_INIT',
                        payload: data
                    });

                    if (res.data.data.lecture.lecture_mode === 'default') {
                        if(res.data.data.lecture.lecture_type === 'pay_channel') {
                            window.MtaH5 && MtaH5.clickStat("live_pay_introduce_page")
                        }
                        this.setState({
                            init: true,
                            lecture: res.data.data,
                            hasAudio: false
                        })
                    } else {
                        this.setState({
                            init: true,
                            lecture: res.data.data,
                            hasAudio: true,
                        })
                    }

                    this.props.dispatch({
                        type: 'UPDATE_SHARE_DATA',
                        payload: {
                            title: data.share_info.share_title,
                            desc: data.share_info.share_description,
                            imgUrl: data.share_info.share_icon,
                            type: data.share_info.share_type,
                            dataUrl: data.share_info.share_data_url,
                            link: data.share_info.share_url,
                            objectType: 'lecture',
                            objectId: lecture_id,
                            is_resell: !!data.resell,
                            liveroom_id: data.liveroom.id
                        }
                    });

                    this.setState({
                        granted: data.lecture.lecture_type === 'open_lecture' ||
                        data.lecture_access.granted ||
                        (data.channel_access && data.channel_access.granted) ||
                        data.role.is_liveroom_vip
                    })
                    if(data.lecture.lecture_mode === 'audio' || data.lecture.lecture_mode === 'video'){
                        if (data.channel) {
                            storage.setItem(`wk-intoclass-${data.channel.id}`, `${lecture_id}-record`)
                        }
                    }
                
                }
            }).catch((error) => {
            if (error.response && error.response.status === 404) {
                const code = error.response.data.code
                if (code === 4041) {
                    return browserHistory.replace('/lecture/error/delete/lecture')
                }
                if (code === 4042) {
                    return browserHistory.replace('/lecture/error/illegal/lecture')
                }
                browserHistory.replace('/lecture/error/delete/lecture')
            }else{
                console.log(error)
            }
        });
    }

    render() {

        if (this.state.init) {

            if (this.props.location.query.discount_code){
                return <LecturePage params={this.props.params}/>
            }

            if (this.state.lecture.lecture.limit_money){
                return <LecturePage params={this.props.params}/>
            }

            /*if (this.state.lecture.channel_access && !this.state.lecture.role.is_manager && !this.state.lecture.role.is_lecturer && this.state.lecture.channel_access.granted && this.state.lecture.lecture.lecture_type === 'password_lecture' && !this.state.lecture.lecture_access.granted){
                return <LecturePage params={this.props.params}/>
            }*/

            if (this.state.granted) {
                if (this.state.hasAudio) {
                    if (this.state.lecture.lecture.lecture_mode === 'audio'){
                        return <RecordedPage lecture={this.state.lecture} type={'audio'}/>
                    }

                    if (this.state.lecture.lecture.lecture_mode === 'video'){
                        return <RecordedPage lecture={this.state.lecture} type={'video'}/>

                    }
                } else {
                    return <LecturePage params={this.props.params}/>
                }
            }else {
                /*if (this.state.lecture.lecture.lecture_type === 'password_lecture' && !this.state.lecture.role.is_manager && !this.state.lecture.role.is_lecturer) {
                    return <LecturePage params={this.props.params}/>
                }*/

                if (this.state.hasAudio) {
                    if (this.state.lecture.lecture.lecture_mode === 'audio'){
                        return <RecordedPage lecture={this.state.lecture} type={'audio'}/>
                    }

                    if (this.state.lecture.lecture.lecture_mode === 'video'){
                        return <RecordedPage lecture={this.state.lecture} type={'video'}/>
                    }
                } else {
                    return <LecturePage params={this.props.params}/>
                }
            }
        } else {
            return <div className="wk-page">
                <Preload />
            </div>
        }

    }
}

export default connect(state => ({
    account: state.account,
}))(LecturePageContainer)



// WEBPACK FOOTER //
// ./src/pages/LecturePageContainer.js